<template>
  <div class="modal-card glass-modal" style="width: auto; max-width: 800px;">
    <header class="modal-card-head glass-header">
      <p class="modal-card-title has-text-white">{{ producto.id ? 'Editar Producto' : 'Nuevo Producto' }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body glass-body">
      <div class="columns is-multiline">
        <div class="column is-half">
          <b-field label="Nombre del Producto" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="producto.nombre" placeholder="Ej: Burger Especial" expanded class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Restaurante" custom-class="has-text-grey-light" class="glass-field">
            <b-select v-model="producto.restaurante_id" expanded class="is-rounded">
              <optgroup label="Selecciona el restaurante">
                <option v-for="rest in restaurantes" :key="rest.id" :value="rest.id">
                  {{ rest.nombre }}
                </option>
              </optgroup>
            </b-select>
          </b-field>
        </div>

        <div class="column is-full">
          <b-field label="Descripción" custom-class="has-text-grey-light" class="glass-field">
            <b-input type="textarea" v-model="producto.descripcion" placeholder="Detalles del producto..." class="glass-textarea" />
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Evento Vinculado" custom-class="has-text-grey-light" class="glass-field">
            <b-select v-model="producto.evento_id" expanded class="is-rounded">
              <option :value="null">Ninguno</option>
              <optgroup label="Eventos Disponibles">
                <option v-for="ev in eventos" :key="ev.id" :value="ev.id">
                  {{ ev.nombre }}
                </option>
              </optgroup>
            </b-select>
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Estado" custom-class="has-text-grey-light" class="glass-field">
            <div class="is-flex is-align-items-center mt-2">
              <b-switch v-model="producto.activo" type="is-success" passive-type="is-danger">
                {{ producto.activo ? 'Publicado' : 'Borrador' }}
              </b-switch>
            </div>
          </b-field>
        </div>

        <div class="column is-full">
          <b-field label="Galería de Fotos" custom-class="has-text-grey-light" class="glass-field">
            <b-upload v-model="imagenesArchivos" multiple drag-drop accept="image/*" @input="subirFotos" class="glass-upload">
              <section class="section has-text-centered py-4">
                <b-icon icon="cloud-upload" size="is-large" class="has-text-primary" />
                <p class="has-text-white mt-1">Arrastra fotos aquí</p>
              </section>
            </b-upload>
          </b-field>
          <div v-if="subiendo" class="has-text-centered py-2">
            <b-loading :is-full-page="false" :active.sync="subiendo" />
            <span class="has-text-info is-size-7">Subiendo imágenes...</span>
          </div>
          <div class="columns is-multiline mt-3">
            <div v-for="(foto, index) in fotos" :key="index" class="column is-3 animate__animated animate__zoomIn">
              <div class="photo-preview shadow-soft">
                <img :src="foto" alt="preview" />
                <button class="delete is-small remove-photo" @click="eliminarFoto(index)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot glass-footer is-justify-content-center">
      <b-button type="is-primary" icon-left="check" class="is-rounded is-medium glass-btn px-6" @click.prevent="registrar">
        {{ producto.id ? 'Actualizar Producto' : 'Crear Producto' }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService';
import Swal from 'sweetalert2';

export default {
  name: 'FormProducto',
  props: {
    productoProp: { type: Object, default: null },
    restauranteId: { type: Number, required: true },
    idEventoProp: { type: [Number, String], default: null }
  },
  data() {
    return {
      producto: {
        nombre: '',
        descripcion: '',
        activo: true,
        restaurante_id: this.restauranteId,
        evento_id: this.idEventoProp,
        id: null
      },
      imagenesArchivos: [],
      fotos: [],
      subiendo: false,
      eventos: [],
      restaurantes: []
    }
  },
  mounted() {
    this.cargarDatos();
  },
  methods: {
    cargarDatos() {
      HttpService.registrar('eventos.php', { accion: 'obtener' }).then(res => { this.eventos = res || []; });
      HttpService.registrar('restaurantes.php', { accion: 'obtener' }).then(res => { this.restaurantes = res || []; });
    },
    async subirFotos(files) {
      if (!files || files.length === 0) return;
      this.subiendo = true;
      for (let file of files) {
        const formData = new FormData();
        formData.append('image', file);
        try {
          const res = await HttpService.subirArchivo('subir_imagen.php', formData);
          if (res.success) this.fotos.push(res.path);
        } catch (e) {
          console.error('Error al subir', e);
        }
      }
      this.subiendo = false;
    },
    eliminarFoto(index) {
      this.fotos.splice(index, 1);
    },
    registrar() {
      if (!this.producto.nombre || !this.producto.restaurante_id) {
        return Swal.fire('Error', 'Nombre y restaurante son obligatorios', 'error');
      }
      const producto = { ...this.producto };
      producto.fotos = this.fotos.map((url, i) => ({ url, posicion: i + 1 }));
      this.$emit('registrar', producto);
    }
  },
  watch: {
    productoProp: {
      immediate: true,
      handler(nuevo) {
        if (nuevo) {
          Object.assign(this.producto, nuevo);
          this.producto.activo = !!Number(this.producto.activo);
          this.fotos = Array.isArray(nuevo.fotos) ? [...nuevo.fotos] : [];
        } else {
          this.producto = {
            nombre: '', descripcion: '', activo: true,
            restaurante_id: this.restauranteId, evento_id: this.idEventoProp, id: null
          };
          this.fotos = [];
        }
      }
    }
  }
};
</script>

<style scoped>
.glass-modal {
  background: rgba(43, 43, 43, 0.85) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px !important;
  overflow: hidden;
}

.glass-header {
  background: rgba(255, 255, 255, 0.05) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-body {
  background: transparent !important;
  padding: 30px !important;
}

.glass-footer {
  background: rgba(255, 255, 255, 0.05) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 20px !important;
}

.glass-field /deep/ .input, .glass-field /deep/ .select select, .glass-textarea /deep/ .textarea {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s;
}

.glass-field /deep/ .input:focus, .glass-field /deep/ .select select:focus, .glass-textarea /deep/ .textarea:focus {
  background: rgba(255, 255, 255, 0.12);
  border-color: #00d1b2;
  box-shadow: 0 0 10px rgba(0, 209, 178, 0.2);
}

.glass-upload /deep/ .upload-draggable {
  border: 2px dashed rgba(255, 255, 255, 0.2) !important;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
}

.photo-preview {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  height: 120px;
}

.photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-photo {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(255, 56, 96, 0.8) !important;
}

.glass-btn {
  background: linear-gradient(135deg, #00d1b2 0%, #009e86 100%);
  border: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(0, 209, 178, 0.3);
}

.glass-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 209, 178, 0.4);
}

::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }
</style>

